export default __webpack_public_path__ + "static/media/arab_flag.c367ccd3.png";